import useEntity from 'core/hooks/useEntity'

const useContact = (...args) => useEntity('contacts', ...args)
export default useContact
